document.addEventListener('alpine:init', () => {

    /**
     * Object to check form data changes and manage the prevention of navigation.
     */
    Alpine.data('navigationAway', () => ({

        /**
         * Init hooks to track wire status.
         *
         * @return void
         */
        init() {
            initEventListeners(this.$root, this.$wire);
        },
    }));
});

/**
 * Initialize event listeners to allow or prevent navigation away.
 *
 * @param {HTMLFormElement} element
 * @param {Object} wireObject
 *
 * @return void
 */
export function initEventListeners(element, wireObject) {
    preventOrAllowNavigationAway(element, wireObject);
    Livewire.on(constants['navigation_away_is_prevented'], () => preventNavigationAway());
    Livewire.on(constants['navigation_away_is_allowed'], () => allowNavigationAway());
}

/**
 * Prevent navigation away if any of inputs has been modified.
 *
 * @param {HTMLFormElement} element
 * @param {Object} wireObject
 *
 * @return void
 */
export function preventOrAllowNavigationAway(element, wireObject) {
    element.querySelectorAll('select, input, textarea').forEach(element => {
        const model = [...element.attributes].filter(({name}) => name.startsWith('wire:model'))[0]?.nodeValue;
        if (undefined !== model) {
            const clean = wireObject.get(model);
            ['change', 'keydown', 'paste', 'input'].forEach(action => {
                if (element.closest('form')) {
                    element.addEventListener(action, (event) => {
                        const value = 'checkbox' === event.target.type ? event.target.checked : event.target.value;
                        clean !== value ? preventNavigationAway() : allowNavigationAway();
                    });
                }
            });
        }
    });
}

/**
 * Enable the native browser prompt about navigation from page.
 *
 * @return void
 */
export function preventNavigationAway() {
    window.onbeforeunload = () => true;
}

 /**
 * Cancel the prevention of navigation.
 *
 * @return void
 */
export function allowNavigationAway() {
    window.onbeforeunload = () => null;
}
